import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { usePool } from '@/api/pools'
import { useWorkspace } from '@/api/workspace'
import { LoadingSkeleton } from '@/components/loading-skeleton'
import { PoolForm } from '@/components/materials/pool-form'

// Pool edit (UI-SCREENS M-02, #64). Owner only; kind is disabled on a used Pool, the unit follows it.
export const Route = createFileRoute('/w/$slug/materials/pools/$poolId/edit')({
  component: EditPool,
  staticData: { breadcrumb: 'materials.form.editTitle' },
})

function EditPool() {
  const { t } = useTranslation()
  const { slug, poolId } = Route.useParams()
  const workspace = useWorkspace(slug)
  const pool = usePool(slug, Number(poolId))

  if (workspace.data && workspace.data.role !== 'owner') {
    return <Navigate to="/w/$slug/materials" params={{ slug }} replace />
  }

  return (
    <section className="flex flex-col gap-4">
      <h1 className="font-heading text-xl font-semibold">{t('materials.form.editTitle')}</h1>
      {pool.isPending ? (
        <LoadingSkeleton variant="form" rows={4} />
      ) : pool.isError || !pool.data ? (
        <p role="alert" className="text-sm text-destructive">
          {t('errors.generic')}
        </p>
      ) : (
        <PoolForm slug={slug} pool={pool.data} />
      )}
    </section>
  )
}
